export default "__VITE_ASSET__BXCYHTNZ__"